import { Component, OnInit, Input } from '@angular/core';
import { ArchivoService } from '../../../providers/archivo.service';
import { HttpEventType, HttpResponse } from '@angular/common/http';

@Component({
  selector: 'app-downloader',
  templateUrl: './downloader.component.html',
  styleUrls: ['./downloader.component.scss']
})
export class DownloaderComponent implements OnInit {
  @Input() removibles: boolean = false;
  @Input() titulo: boolean = true;
  @Input() paddingTop: number = 16;
  @Input() showEmpty: boolean = true;

  private _archivos: any[];
  @Input() set archivos(value: any[]) {
    this._archivos = value;
  }
  get archivos(): any[] {
    return this._archivos;
  }

  private _disabled: boolean;
  @Input() set disabled(value: boolean) {
    this._disabled = value;
  }
  get disabled(): boolean {
    return this._disabled;
  }

  private _tituloDescripcion: string = 'Archivos cargados';
  @Input() set tituloDescripcion(value: string) {
    this._tituloDescripcion = value;
  }
  get tituloDescripcion(): string {
    return this._tituloDescripcion;
  }

  remove(archivo) {
    this.archivos.splice(this.archivos.indexOf(archivo), 1);
  }

  constructor(
    private _archivoSv: ArchivoService
  ) { }

  ngOnInit() {
  }

  download(archivo) {
    if (archivo) {
      this._downloadFile(archivo);
    }
  }

  private _downloadFile(archivo): Promise<boolean> {
    return new Promise<boolean>(resolve => {
      archivo['downloading'] = true;
      archivo['porcentaje'] = 0;
      this._archivoSv.descargar(archivo).subscribe(
        (event) => {
          switch (event.type) {
            case HttpEventType.DownloadProgress:
              archivo['size'] = event.total;
              archivo.porcentaje = +(event.loaded * 100 / event.total).toFixed(0);
              break;
            case HttpEventType.Response:
              const response = <HttpResponse<any>>event;
              if (response.status == 200 && response.ok) {
                const buffer = response.body;
                this._bufferToFile(buffer, archivo);
              }
              setTimeout(() => {
                archivo.downloading = false;
                resolve(true);
              }, 750);
              break;
          }
        },
        () => {
          archivo.downloading = false;
          resolve(false);
        });
    });
  }

  /**
  * Method is use to download file.
  * @param buffer - Array Buffer data
  * @param type - type of the document.
  */
  private _bufferToFile(buffer: any, archivo) {
    const blob = new Blob([buffer], { type: archivo.tipo });
    const url = window.URL.createObjectURL(blob);
    let downloadLink = document.createElement("a");
    downloadLink.href = encodeURI(url);
    downloadLink.download = archivo.nombre + '.' + archivo.extension;
    downloadLink.target = "_blank";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }
}
